import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { EntityCardProps } from '../types';
import { entityIcons } from '../utils/styles';
import type { EntityType } from '../types';

export const EntityCard: React.FC<EntityCardProps> = ({ entity }) => {
  const [showContext, setShowContext] = useState(false);
  const IconComponent = entityIcons[entity.label as EntityType] || entityIcons.default;

  return (
    <div className="glass-effect p-4 rounded-lg hover:bg-purple-500/20 transition-all duration-200">
      <div className="flex justify-between items-start gap-4">
        <div className="flex-1 min-w-0"> {/* min-w-0 prevents flex item from overflowing */}
          <div className="flex items-center gap-2 mb-2">
            <IconComponent className="w-4 h-4 text-purple-400 shrink-0" />
            <span className="text-xs font-semibold text-purple-300 truncate">
              {entity.label}
            </span>
          </div>
          <p className="text-lg font-medium text-white break-words">
            {entity.text}
          </p>
          <div className="flex items-center mt-2 gap-2">
            <div className="w-16 h-1.5 bg-purple-900/50 rounded-full overflow-hidden shrink-0">
              <div 
                className="h-full bg-purple-400 rounded-full transition-all duration-300"
                style={{ width: `${entity.confidence * 100}%` }}
              />
            </div>
            <span className="text-sm text-purple-400 truncate">
              {(entity.confidence * 100).toFixed(1)}%
            </span>
          </div>
        </div>
        <button
          onClick={() => setShowContext(!showContext)}
          className="text-purple-400 hover:text-purple-300 p-2 hover:bg-purple-500/20 rounded-lg transition-colors shrink-0"
          title={showContext ? "Hide context" : "Show context"}
        >
          <Search className="w-5 h-5" />
        </button>
      </div>
      {showContext && (
        <div className="mt-3 pt-3 border-t border-purple-500/20">
          <p className="text-sm text-purple-300 break-words">
            <span className="font-medium text-purple-200">Context:</span> {entity.context}
          </p>
        </div>
      )}
    </div>
  );
};